import React from "react";
import { EntryIcon } from "./PublicEntryUI";

const FEATURES = [
  {
    icon: "web",
    category: "PRESENCIA ONLINE",
    title: "Un lugar propio para tu negocio.",
    text: "Mostrá quién sos, qué ofrecés y cómo contactarte con una página que podés editar vos.",
    tags: ["Página web", "Productos y servicios", "Consultas"],
    tone: "cream",
  },
  {
    icon: "bag",
    category: "VENTAS",
    title: "De la consulta a la venta.",
    text: "Conectá tu catálogo con pedidos, cobros online y seguimiento de clientes desde el mismo espacio.",
    tags: ["Catálogo", "Pedidos y cobros", "Clientes"],
    tone: "peach",
  },
  {
    icon: "chart",
    category: "GESTIÓN",
    title: "Menos dispersión. Más control.",
    text: "Sumá stock, cajas, agenda o mensualidades según lo que tu negocio necesite ordenar.",
    tags: ["Stock y cajas", "Turnos", "Mensualidades"],
    tone: "sage",
  },
];

export default function HomeProductOverview() {
  return (
    <section
      className="wp-home-product"
      id="producto"
      tabIndex={-1}
      aria-labelledby="wp-product-title"
    >
      <div className="wp-entry-container">
        <div className="wp-home-section-heading">
          <p className="wp-entry-eyebrow">QUÉ PODÉS HACER</p>
          <h2 id="wp-product-title">
            Más conectado.
            <br />
            Menos complicado.
          </h2>
          <p>
            Una base para empezar. Más posibilidades para cuando tu negocio las
            pida.
          </p>
        </div>
        <div className="wp-home-feature-grid">
          {FEATURES.map((feature, index) => (
            <article
              className={`wp-home-feature wp-home-feature-${feature.tone}`}
              key={feature.title}
            >
              <div className="wp-home-feature-top">
                <EntryIcon name={feature.icon} size={29} />
                <span>0{index + 1}</span>
              </div>
              <p className="wp-entry-eyebrow">{feature.category}</p>
              <h3>{feature.title}</h3>
              <p className="wp-home-feature-text">{feature.text}</p>
              <ul
                aria-label={`Herramientas de ${feature.category.toLowerCase()}`}
              >
                {feature.tags.map((tag) => (
                  <li key={tag}>{tag}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
        <p className="wp-home-module-note">
          La página web es gratuita. Los módulos de venta y gestión se activan
          por separado según tu plan.
        </p>
      </div>
    </section>
  );
}
